/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const getPaymentMercadoPago = /* GraphQL */ `mutation GetPaymentMercadoPago(
  $id: ID!
  $paymentId: String!
  $salesforceId: String!
) {
  getPaymentMercadoPago(
    id: $id
    paymentId: $paymentId
    salesforceId: $salesforceId
  ) {
    payment_id
    amount
    payment_date
    currency
    country
    __typename
  }
}
` as GeneratedMutation<
  APITypes.GetPaymentMercadoPagoMutationVariables,
  APITypes.GetPaymentMercadoPagoMutation
>;
export const createPreferenceMercadoPago = /* GraphQL */ `mutation CreatePreferenceMercadoPago(
  $id: ID!
  $amount: Int!
  $salesforceId: String!
  $country: String
  $currency: String
) {
  createPreferenceMercadoPago(
    id: $id
    amount: $amount
    salesforceId: $salesforceId
    country: $country
    currency: $currency
  ) {
    preference_id
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePreferenceMercadoPagoMutationVariables,
  APITypes.CreatePreferenceMercadoPagoMutation
>;
export const updatePhone = /* GraphQL */ `mutation UpdatePhone($id: ID!, $phone: String!, $kyc: Boolean) {
  updatePhone(id: $id, phone: $phone, kyc: $kyc) {
    updatedPhone
    reload
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePhoneMutationVariables,
  APITypes.UpdatePhoneMutation
>;
export const confirmCode = /* GraphQL */ `mutation ConfirmCode($id: ID!, $code: String!, $kyc: Boolean) {
  confirmCode(id: $id, code: $code, kyc: $kyc) {
    confirmPhone
    wasPhoneValidate
    kycNextStep
    __typename
  }
}
` as GeneratedMutation<
  APITypes.ConfirmCodeMutationVariables,
  APITypes.ConfirmCodeMutation
>;
export const notReceivedCode = /* GraphQL */ `mutation NotReceivedCode($id: ID!, $kyc: Boolean) {
  notReceivedCode(id: $id, kyc: $kyc) {
    id
    cognitoId
    identityId
    salesforceId
    givenName
    familyName
    email
    phone
    birth
    dni
    signUpCountry
    originCountry
    residenceCountry
    city
    address
    job
    liveInUSA
    isPEP
    riskProfile
    riskPoints
    knowledgeProfile
    knowledgePoints
    userProfileSignature
    isKycApproved
    acceptTerms
    userAcceptTermsSignature
    customerStatus
    customerType
    customerCategory
    kycNextStep
    sf_Broker__c
    subaccounts {
      total_deposit_clp
      total_ransom_pen
      total_deposit_usd
      total_ransom_clp
      total_ransom_usd
      total_deposit_pen
      name
      currency
      __typename
    }
    wasIdFileUploaded
    userIdFileSignature
    frontSideIdFilePath
    backSideIdFilePath
    wasAddressFileUploaded
    userAddressFileSignature
    addressFilePath
    wasCardFileUploaded
    userCardFileSignature
    cardFilePath
    wasLivenessFileUploaded
    confirmPhone
    wasPhoneValidate
    wasCreatedInMarketingCloud
    wasCreatedInSalesforce
    needKyc
    require_metamap_upload
    utmSource
    utmMedium
    utmCampaign
    utmId
    createdAt
    updatedAt
    validatePersonalInfo
    __typename
  }
}
` as GeneratedMutation<
  APITypes.NotReceivedCodeMutationVariables,
  APITypes.NotReceivedCodeMutation
>;
export const validateIdentity = /* GraphQL */ `mutation ValidateIdentity($id: ID!, $cognitoId: ID!) {
  validateIdentity(id: $id, cognitoId: $cognitoId) {
    id
    cognitoId
    identityId
    salesforceId
    givenName
    familyName
    email
    phone
    birth
    dni
    signUpCountry
    originCountry
    residenceCountry
    city
    address
    job
    liveInUSA
    isPEP
    riskProfile
    riskPoints
    knowledgeProfile
    knowledgePoints
    userProfileSignature
    isKycApproved
    acceptTerms
    userAcceptTermsSignature
    customerStatus
    customerType
    customerCategory
    kycNextStep
    sf_Broker__c
    subaccounts {
      total_deposit_clp
      total_ransom_pen
      total_deposit_usd
      total_ransom_clp
      total_ransom_usd
      total_deposit_pen
      name
      currency
      __typename
    }
    wasIdFileUploaded
    userIdFileSignature
    frontSideIdFilePath
    backSideIdFilePath
    wasAddressFileUploaded
    userAddressFileSignature
    addressFilePath
    wasCardFileUploaded
    userCardFileSignature
    cardFilePath
    wasLivenessFileUploaded
    confirmPhone
    wasPhoneValidate
    wasCreatedInMarketingCloud
    wasCreatedInSalesforce
    needKyc
    require_metamap_upload
    utmSource
    utmMedium
    utmCampaign
    utmId
    createdAt
    updatedAt
    validatePersonalInfo
    __typename
  }
}
` as GeneratedMutation<
  APITypes.ValidateIdentityMutationVariables,
  APITypes.ValidateIdentityMutation
>;
export const createEvent = /* GraphQL */ `mutation CreateEvent($id: ID!, $event: EventInput!) {
  createEvent(id: $id, event: $event)
}
` as GeneratedMutation<
  APITypes.CreateEventMutationVariables,
  APITypes.CreateEventMutation
>;
export const updateCustomerType = /* GraphQL */ `mutation UpdateCustomerType($id: ID!, $customerType: CustomerType!) {
  updateCustomerType(id: $id, customerType: $customerType) {
    id
    cognitoId
    identityId
    salesforceId
    givenName
    familyName
    email
    phone
    birth
    dni
    signUpCountry
    originCountry
    residenceCountry
    city
    address
    job
    liveInUSA
    isPEP
    riskProfile
    riskPoints
    knowledgeProfile
    knowledgePoints
    userProfileSignature
    isKycApproved
    acceptTerms
    userAcceptTermsSignature
    customerStatus
    customerType
    customerCategory
    kycNextStep
    sf_Broker__c
    subaccounts {
      total_deposit_clp
      total_ransom_pen
      total_deposit_usd
      total_ransom_clp
      total_ransom_usd
      total_deposit_pen
      name
      currency
      __typename
    }
    wasIdFileUploaded
    userIdFileSignature
    frontSideIdFilePath
    backSideIdFilePath
    wasAddressFileUploaded
    userAddressFileSignature
    addressFilePath
    wasCardFileUploaded
    userCardFileSignature
    cardFilePath
    wasLivenessFileUploaded
    confirmPhone
    wasPhoneValidate
    wasCreatedInMarketingCloud
    wasCreatedInSalesforce
    needKyc
    require_metamap_upload
    utmSource
    utmMedium
    utmCampaign
    utmId
    createdAt
    updatedAt
    validatePersonalInfo
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateCustomerTypeMutationVariables,
  APITypes.UpdateCustomerTypeMutation
>;
export const updatePersonalInfo = /* GraphQL */ `mutation UpdatePersonalInfo($id: ID!, $personalInfo: PersonalInfo!) {
  updatePersonalInfo(id: $id, personalInfo: $personalInfo) {
    id
    cognitoId
    identityId
    salesforceId
    givenName
    familyName
    email
    phone
    birth
    dni
    signUpCountry
    originCountry
    residenceCountry
    city
    address
    job
    liveInUSA
    isPEP
    riskProfile
    riskPoints
    knowledgeProfile
    knowledgePoints
    userProfileSignature
    isKycApproved
    acceptTerms
    userAcceptTermsSignature
    customerStatus
    customerType
    customerCategory
    kycNextStep
    sf_Broker__c
    subaccounts {
      total_deposit_clp
      total_ransom_pen
      total_deposit_usd
      total_ransom_clp
      total_ransom_usd
      total_deposit_pen
      name
      currency
      __typename
    }
    wasIdFileUploaded
    userIdFileSignature
    frontSideIdFilePath
    backSideIdFilePath
    wasAddressFileUploaded
    userAddressFileSignature
    addressFilePath
    wasCardFileUploaded
    userCardFileSignature
    cardFilePath
    wasLivenessFileUploaded
    confirmPhone
    wasPhoneValidate
    wasCreatedInMarketingCloud
    wasCreatedInSalesforce
    needKyc
    require_metamap_upload
    utmSource
    utmMedium
    utmCampaign
    utmId
    createdAt
    updatedAt
    validatePersonalInfo
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePersonalInfoMutationVariables,
  APITypes.UpdatePersonalInfoMutation
>;
export const updateSelectCourse = /* GraphQL */ `mutation UpdateSelectCourse($id: ID!, $course: String!) {
  updateSelectCourse(id: $id, course: $course) {
    id
    cognitoId
    identityId
    salesforceId
    givenName
    familyName
    email
    phone
    birth
    dni
    signUpCountry
    originCountry
    residenceCountry
    city
    address
    job
    liveInUSA
    isPEP
    riskProfile
    riskPoints
    knowledgeProfile
    knowledgePoints
    userProfileSignature
    isKycApproved
    acceptTerms
    userAcceptTermsSignature
    customerStatus
    customerType
    customerCategory
    kycNextStep
    sf_Broker__c
    subaccounts {
      total_deposit_clp
      total_ransom_pen
      total_deposit_usd
      total_ransom_clp
      total_ransom_usd
      total_deposit_pen
      name
      currency
      __typename
    }
    wasIdFileUploaded
    userIdFileSignature
    frontSideIdFilePath
    backSideIdFilePath
    wasAddressFileUploaded
    userAddressFileSignature
    addressFilePath
    wasCardFileUploaded
    userCardFileSignature
    cardFilePath
    wasLivenessFileUploaded
    confirmPhone
    wasPhoneValidate
    wasCreatedInMarketingCloud
    wasCreatedInSalesforce
    needKyc
    require_metamap_upload
    utmSource
    utmMedium
    utmCampaign
    utmId
    createdAt
    updatedAt
    validatePersonalInfo
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateSelectCourseMutationVariables,
  APITypes.UpdateSelectCourseMutation
>;
export const updateValidationDeposit = /* GraphQL */ `mutation UpdateValidationDeposit($id: ID!) {
  updateValidationDeposit(id: $id) {
    id
    cognitoId
    identityId
    salesforceId
    givenName
    familyName
    email
    phone
    birth
    dni
    signUpCountry
    originCountry
    residenceCountry
    city
    address
    job
    liveInUSA
    isPEP
    riskProfile
    riskPoints
    knowledgeProfile
    knowledgePoints
    userProfileSignature
    isKycApproved
    acceptTerms
    userAcceptTermsSignature
    customerStatus
    customerType
    customerCategory
    kycNextStep
    sf_Broker__c
    subaccounts {
      total_deposit_clp
      total_ransom_pen
      total_deposit_usd
      total_ransom_clp
      total_ransom_usd
      total_deposit_pen
      name
      currency
      __typename
    }
    wasIdFileUploaded
    userIdFileSignature
    frontSideIdFilePath
    backSideIdFilePath
    wasAddressFileUploaded
    userAddressFileSignature
    addressFilePath
    wasCardFileUploaded
    userCardFileSignature
    cardFilePath
    wasLivenessFileUploaded
    confirmPhone
    wasPhoneValidate
    wasCreatedInMarketingCloud
    wasCreatedInSalesforce
    needKyc
    require_metamap_upload
    utmSource
    utmMedium
    utmCampaign
    utmId
    createdAt
    updatedAt
    validatePersonalInfo
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateValidationDepositMutationVariables,
  APITypes.UpdateValidationDepositMutation
>;
export const updatePlatform = /* GraphQL */ `mutation UpdatePlatform($id: ID!) {
  updatePlatform(id: $id) {
    id
    cognitoId
    identityId
    salesforceId
    givenName
    familyName
    email
    phone
    birth
    dni
    signUpCountry
    originCountry
    residenceCountry
    city
    address
    job
    liveInUSA
    isPEP
    riskProfile
    riskPoints
    knowledgeProfile
    knowledgePoints
    userProfileSignature
    isKycApproved
    acceptTerms
    userAcceptTermsSignature
    customerStatus
    customerType
    customerCategory
    kycNextStep
    sf_Broker__c
    subaccounts {
      total_deposit_clp
      total_ransom_pen
      total_deposit_usd
      total_ransom_clp
      total_ransom_usd
      total_deposit_pen
      name
      currency
      __typename
    }
    wasIdFileUploaded
    userIdFileSignature
    frontSideIdFilePath
    backSideIdFilePath
    wasAddressFileUploaded
    userAddressFileSignature
    addressFilePath
    wasCardFileUploaded
    userCardFileSignature
    cardFilePath
    wasLivenessFileUploaded
    confirmPhone
    wasPhoneValidate
    wasCreatedInMarketingCloud
    wasCreatedInSalesforce
    needKyc
    require_metamap_upload
    utmSource
    utmMedium
    utmCampaign
    utmId
    createdAt
    updatedAt
    validatePersonalInfo
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePlatformMutationVariables,
  APITypes.UpdatePlatformMutation
>;
export const updateRiskProfile = /* GraphQL */ `mutation UpdateRiskProfile($id: ID!, $userAnswer: AWSJSON!) {
  updateRiskProfile(id: $id, userAnswer: $userAnswer) {
    id
    cognitoId
    identityId
    salesforceId
    givenName
    familyName
    email
    phone
    birth
    dni
    signUpCountry
    originCountry
    residenceCountry
    city
    address
    job
    liveInUSA
    isPEP
    riskProfile
    riskPoints
    knowledgeProfile
    knowledgePoints
    userProfileSignature
    isKycApproved
    acceptTerms
    userAcceptTermsSignature
    customerStatus
    customerType
    customerCategory
    kycNextStep
    sf_Broker__c
    subaccounts {
      total_deposit_clp
      total_ransom_pen
      total_deposit_usd
      total_ransom_clp
      total_ransom_usd
      total_deposit_pen
      name
      currency
      __typename
    }
    wasIdFileUploaded
    userIdFileSignature
    frontSideIdFilePath
    backSideIdFilePath
    wasAddressFileUploaded
    userAddressFileSignature
    addressFilePath
    wasCardFileUploaded
    userCardFileSignature
    cardFilePath
    wasLivenessFileUploaded
    confirmPhone
    wasPhoneValidate
    wasCreatedInMarketingCloud
    wasCreatedInSalesforce
    needKyc
    require_metamap_upload
    utmSource
    utmMedium
    utmCampaign
    utmId
    createdAt
    updatedAt
    validatePersonalInfo
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateRiskProfileMutationVariables,
  APITypes.UpdateRiskProfileMutation
>;
export const updateKnowledgeProfile = /* GraphQL */ `mutation UpdateKnowledgeProfile($id: ID!, $userAnswer: AWSJSON!) {
  updateKnowledgeProfile(id: $id, userAnswer: $userAnswer) {
    id
    cognitoId
    identityId
    salesforceId
    givenName
    familyName
    email
    phone
    birth
    dni
    signUpCountry
    originCountry
    residenceCountry
    city
    address
    job
    liveInUSA
    isPEP
    riskProfile
    riskPoints
    knowledgeProfile
    knowledgePoints
    userProfileSignature
    isKycApproved
    acceptTerms
    userAcceptTermsSignature
    customerStatus
    customerType
    customerCategory
    kycNextStep
    sf_Broker__c
    subaccounts {
      total_deposit_clp
      total_ransom_pen
      total_deposit_usd
      total_ransom_clp
      total_ransom_usd
      total_deposit_pen
      name
      currency
      __typename
    }
    wasIdFileUploaded
    userIdFileSignature
    frontSideIdFilePath
    backSideIdFilePath
    wasAddressFileUploaded
    userAddressFileSignature
    addressFilePath
    wasCardFileUploaded
    userCardFileSignature
    cardFilePath
    wasLivenessFileUploaded
    confirmPhone
    wasPhoneValidate
    wasCreatedInMarketingCloud
    wasCreatedInSalesforce
    needKyc
    require_metamap_upload
    utmSource
    utmMedium
    utmCampaign
    utmId
    createdAt
    updatedAt
    validatePersonalInfo
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateKnowledgeProfileMutationVariables,
  APITypes.UpdateKnowledgeProfileMutation
>;
export const updateGoodTraderProfile = /* GraphQL */ `mutation UpdateGoodTraderProfile($id: ID!) {
  updateGoodTraderProfile(id: $id) {
    id
    cognitoId
    identityId
    salesforceId
    givenName
    familyName
    email
    phone
    birth
    dni
    signUpCountry
    originCountry
    residenceCountry
    city
    address
    job
    liveInUSA
    isPEP
    riskProfile
    riskPoints
    knowledgeProfile
    knowledgePoints
    userProfileSignature
    isKycApproved
    acceptTerms
    userAcceptTermsSignature
    customerStatus
    customerType
    customerCategory
    kycNextStep
    sf_Broker__c
    subaccounts {
      total_deposit_clp
      total_ransom_pen
      total_deposit_usd
      total_ransom_clp
      total_ransom_usd
      total_deposit_pen
      name
      currency
      __typename
    }
    wasIdFileUploaded
    userIdFileSignature
    frontSideIdFilePath
    backSideIdFilePath
    wasAddressFileUploaded
    userAddressFileSignature
    addressFilePath
    wasCardFileUploaded
    userCardFileSignature
    cardFilePath
    wasLivenessFileUploaded
    confirmPhone
    wasPhoneValidate
    wasCreatedInMarketingCloud
    wasCreatedInSalesforce
    needKyc
    require_metamap_upload
    utmSource
    utmMedium
    utmCampaign
    utmId
    createdAt
    updatedAt
    validatePersonalInfo
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateGoodTraderProfileMutationVariables,
  APITypes.UpdateGoodTraderProfileMutation
>;
export const updateValidatePersonalInfo = /* GraphQL */ `mutation UpdateValidatePersonalInfo($id: ID!) {
  updateValidatePersonalInfo(id: $id) {
    id
    cognitoId
    identityId
    salesforceId
    givenName
    familyName
    email
    phone
    birth
    dni
    signUpCountry
    originCountry
    residenceCountry
    city
    address
    job
    liveInUSA
    isPEP
    riskProfile
    riskPoints
    knowledgeProfile
    knowledgePoints
    userProfileSignature
    isKycApproved
    acceptTerms
    userAcceptTermsSignature
    customerStatus
    customerType
    customerCategory
    kycNextStep
    sf_Broker__c
    subaccounts {
      total_deposit_clp
      total_ransom_pen
      total_deposit_usd
      total_ransom_clp
      total_ransom_usd
      total_deposit_pen
      name
      currency
      __typename
    }
    wasIdFileUploaded
    userIdFileSignature
    frontSideIdFilePath
    backSideIdFilePath
    wasAddressFileUploaded
    userAddressFileSignature
    addressFilePath
    wasCardFileUploaded
    userCardFileSignature
    cardFilePath
    wasLivenessFileUploaded
    confirmPhone
    wasPhoneValidate
    wasCreatedInMarketingCloud
    wasCreatedInSalesforce
    needKyc
    require_metamap_upload
    utmSource
    utmMedium
    utmCampaign
    utmId
    createdAt
    updatedAt
    validatePersonalInfo
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateValidatePersonalInfoMutationVariables,
  APITypes.UpdateValidatePersonalInfoMutation
>;
export const updateRiskBadTraderProfile = /* GraphQL */ `mutation UpdateRiskBadTraderProfile($id: ID!) {
  updateRiskBadTraderProfile(id: $id) {
    id
    cognitoId
    identityId
    salesforceId
    givenName
    familyName
    email
    phone
    birth
    dni
    signUpCountry
    originCountry
    residenceCountry
    city
    address
    job
    liveInUSA
    isPEP
    riskProfile
    riskPoints
    knowledgeProfile
    knowledgePoints
    userProfileSignature
    isKycApproved
    acceptTerms
    userAcceptTermsSignature
    customerStatus
    customerType
    customerCategory
    kycNextStep
    sf_Broker__c
    subaccounts {
      total_deposit_clp
      total_ransom_pen
      total_deposit_usd
      total_ransom_clp
      total_ransom_usd
      total_deposit_pen
      name
      currency
      __typename
    }
    wasIdFileUploaded
    userIdFileSignature
    frontSideIdFilePath
    backSideIdFilePath
    wasAddressFileUploaded
    userAddressFileSignature
    addressFilePath
    wasCardFileUploaded
    userCardFileSignature
    cardFilePath
    wasLivenessFileUploaded
    confirmPhone
    wasPhoneValidate
    wasCreatedInMarketingCloud
    wasCreatedInSalesforce
    needKyc
    require_metamap_upload
    utmSource
    utmMedium
    utmCampaign
    utmId
    createdAt
    updatedAt
    validatePersonalInfo
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateRiskBadTraderProfileMutationVariables,
  APITypes.UpdateRiskBadTraderProfileMutation
>;
export const updateTerms = /* GraphQL */ `mutation UpdateTerms($id: ID!, $acceptTerms: Boolean!) {
  updateTerms(id: $id, acceptTerms: $acceptTerms) {
    id
    cognitoId
    identityId
    salesforceId
    givenName
    familyName
    email
    phone
    birth
    dni
    signUpCountry
    originCountry
    residenceCountry
    city
    address
    job
    liveInUSA
    isPEP
    riskProfile
    riskPoints
    knowledgeProfile
    knowledgePoints
    userProfileSignature
    isKycApproved
    acceptTerms
    userAcceptTermsSignature
    customerStatus
    customerType
    customerCategory
    kycNextStep
    sf_Broker__c
    subaccounts {
      total_deposit_clp
      total_ransom_pen
      total_deposit_usd
      total_ransom_clp
      total_ransom_usd
      total_deposit_pen
      name
      currency
      __typename
    }
    wasIdFileUploaded
    userIdFileSignature
    frontSideIdFilePath
    backSideIdFilePath
    wasAddressFileUploaded
    userAddressFileSignature
    addressFilePath
    wasCardFileUploaded
    userCardFileSignature
    cardFilePath
    wasLivenessFileUploaded
    confirmPhone
    wasPhoneValidate
    wasCreatedInMarketingCloud
    wasCreatedInSalesforce
    needKyc
    require_metamap_upload
    utmSource
    utmMedium
    utmCampaign
    utmId
    createdAt
    updatedAt
    validatePersonalInfo
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateTermsMutationVariables,
  APITypes.UpdateTermsMutation
>;
export const updateDeposit = /* GraphQL */ `mutation UpdateDeposit($id: ID!) {
  updateDeposit(id: $id) {
    id
    cognitoId
    identityId
    salesforceId
    givenName
    familyName
    email
    phone
    birth
    dni
    signUpCountry
    originCountry
    residenceCountry
    city
    address
    job
    liveInUSA
    isPEP
    riskProfile
    riskPoints
    knowledgeProfile
    knowledgePoints
    userProfileSignature
    isKycApproved
    acceptTerms
    userAcceptTermsSignature
    customerStatus
    customerType
    customerCategory
    kycNextStep
    sf_Broker__c
    subaccounts {
      total_deposit_clp
      total_ransom_pen
      total_deposit_usd
      total_ransom_clp
      total_ransom_usd
      total_deposit_pen
      name
      currency
      __typename
    }
    wasIdFileUploaded
    userIdFileSignature
    frontSideIdFilePath
    backSideIdFilePath
    wasAddressFileUploaded
    userAddressFileSignature
    addressFilePath
    wasCardFileUploaded
    userCardFileSignature
    cardFilePath
    wasLivenessFileUploaded
    confirmPhone
    wasPhoneValidate
    wasCreatedInMarketingCloud
    wasCreatedInSalesforce
    needKyc
    require_metamap_upload
    utmSource
    utmMedium
    utmCampaign
    utmId
    createdAt
    updatedAt
    validatePersonalInfo
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateDepositMutationVariables,
  APITypes.UpdateDepositMutation
>;
export const skipDeposit = /* GraphQL */ `mutation SkipDeposit($id: ID!) {
  skipDeposit(id: $id) {
    id
    cognitoId
    identityId
    salesforceId
    givenName
    familyName
    email
    phone
    birth
    dni
    signUpCountry
    originCountry
    residenceCountry
    city
    address
    job
    liveInUSA
    isPEP
    riskProfile
    riskPoints
    knowledgeProfile
    knowledgePoints
    userProfileSignature
    isKycApproved
    acceptTerms
    userAcceptTermsSignature
    customerStatus
    customerType
    customerCategory
    kycNextStep
    sf_Broker__c
    subaccounts {
      total_deposit_clp
      total_ransom_pen
      total_deposit_usd
      total_ransom_clp
      total_ransom_usd
      total_deposit_pen
      name
      currency
      __typename
    }
    wasIdFileUploaded
    userIdFileSignature
    frontSideIdFilePath
    backSideIdFilePath
    wasAddressFileUploaded
    userAddressFileSignature
    addressFilePath
    wasCardFileUploaded
    userCardFileSignature
    cardFilePath
    wasLivenessFileUploaded
    confirmPhone
    wasPhoneValidate
    wasCreatedInMarketingCloud
    wasCreatedInSalesforce
    needKyc
    require_metamap_upload
    utmSource
    utmMedium
    utmCampaign
    utmId
    createdAt
    updatedAt
    validatePersonalInfo
    __typename
  }
}
` as GeneratedMutation<
  APITypes.SkipDepositMutationVariables,
  APITypes.SkipDepositMutation
>;
export const updateIdFileUploaded = /* GraphQL */ `mutation UpdateIdFileUploaded(
  $id: ID!
  $uploaded: Boolean!
  $country: CountryType!
  $typeDocument: String!
  $kyc: Boolean
) {
  updateIdFileUploaded(
    id: $id
    uploaded: $uploaded
    country: $country
    typeDocument: $typeDocument
    kyc: $kyc
  ) {
    id
    cognitoId
    identityId
    salesforceId
    givenName
    familyName
    email
    phone
    birth
    dni
    signUpCountry
    originCountry
    residenceCountry
    city
    address
    job
    liveInUSA
    isPEP
    riskProfile
    riskPoints
    knowledgeProfile
    knowledgePoints
    userProfileSignature
    isKycApproved
    acceptTerms
    userAcceptTermsSignature
    customerStatus
    customerType
    customerCategory
    kycNextStep
    sf_Broker__c
    subaccounts {
      total_deposit_clp
      total_ransom_pen
      total_deposit_usd
      total_ransom_clp
      total_ransom_usd
      total_deposit_pen
      name
      currency
      __typename
    }
    wasIdFileUploaded
    userIdFileSignature
    frontSideIdFilePath
    backSideIdFilePath
    wasAddressFileUploaded
    userAddressFileSignature
    addressFilePath
    wasCardFileUploaded
    userCardFileSignature
    cardFilePath
    wasLivenessFileUploaded
    confirmPhone
    wasPhoneValidate
    wasCreatedInMarketingCloud
    wasCreatedInSalesforce
    needKyc
    require_metamap_upload
    utmSource
    utmMedium
    utmCampaign
    utmId
    createdAt
    updatedAt
    validatePersonalInfo
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateIdFileUploadedMutationVariables,
  APITypes.UpdateIdFileUploadedMutation
>;
export const updateLivenessFileUploaded = /* GraphQL */ `mutation UpdateLivenessFileUploaded(
  $id: ID!
  $uploaded: Boolean!
  $kyc: Boolean
) {
  updateLivenessFileUploaded(id: $id, uploaded: $uploaded, kyc: $kyc) {
    id
    cognitoId
    identityId
    salesforceId
    givenName
    familyName
    email
    phone
    birth
    dni
    signUpCountry
    originCountry
    residenceCountry
    city
    address
    job
    liveInUSA
    isPEP
    riskProfile
    riskPoints
    knowledgeProfile
    knowledgePoints
    userProfileSignature
    isKycApproved
    acceptTerms
    userAcceptTermsSignature
    customerStatus
    customerType
    customerCategory
    kycNextStep
    sf_Broker__c
    subaccounts {
      total_deposit_clp
      total_ransom_pen
      total_deposit_usd
      total_ransom_clp
      total_ransom_usd
      total_deposit_pen
      name
      currency
      __typename
    }
    wasIdFileUploaded
    userIdFileSignature
    frontSideIdFilePath
    backSideIdFilePath
    wasAddressFileUploaded
    userAddressFileSignature
    addressFilePath
    wasCardFileUploaded
    userCardFileSignature
    cardFilePath
    wasLivenessFileUploaded
    confirmPhone
    wasPhoneValidate
    wasCreatedInMarketingCloud
    wasCreatedInSalesforce
    needKyc
    require_metamap_upload
    utmSource
    utmMedium
    utmCampaign
    utmId
    createdAt
    updatedAt
    validatePersonalInfo
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLivenessFileUploadedMutationVariables,
  APITypes.UpdateLivenessFileUploadedMutation
>;
export const updateAddressFileUploaded = /* GraphQL */ `mutation UpdateAddressFileUploaded($id: ID!, $uploaded: Boolean!) {
  updateAddressFileUploaded(id: $id, uploaded: $uploaded) {
    id
    cognitoId
    identityId
    salesforceId
    givenName
    familyName
    email
    phone
    birth
    dni
    signUpCountry
    originCountry
    residenceCountry
    city
    address
    job
    liveInUSA
    isPEP
    riskProfile
    riskPoints
    knowledgeProfile
    knowledgePoints
    userProfileSignature
    isKycApproved
    acceptTerms
    userAcceptTermsSignature
    customerStatus
    customerType
    customerCategory
    kycNextStep
    sf_Broker__c
    subaccounts {
      total_deposit_clp
      total_ransom_pen
      total_deposit_usd
      total_ransom_clp
      total_ransom_usd
      total_deposit_pen
      name
      currency
      __typename
    }
    wasIdFileUploaded
    userIdFileSignature
    frontSideIdFilePath
    backSideIdFilePath
    wasAddressFileUploaded
    userAddressFileSignature
    addressFilePath
    wasCardFileUploaded
    userCardFileSignature
    cardFilePath
    wasLivenessFileUploaded
    confirmPhone
    wasPhoneValidate
    wasCreatedInMarketingCloud
    wasCreatedInSalesforce
    needKyc
    require_metamap_upload
    utmSource
    utmMedium
    utmCampaign
    utmId
    createdAt
    updatedAt
    validatePersonalInfo
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAddressFileUploadedMutationVariables,
  APITypes.UpdateAddressFileUploadedMutation
>;
export const updateCardFileUploaded = /* GraphQL */ `mutation UpdateCardFileUploaded(
  $id: ID!
  $uploaded: Boolean!
  $kyc: Boolean!
  $ommit: Boolean!
) {
  updateCardFileUploaded(
    id: $id
    uploaded: $uploaded
    kyc: $kyc
    ommit: $ommit
  ) {
    id
    cognitoId
    identityId
    salesforceId
    givenName
    familyName
    email
    phone
    birth
    dni
    signUpCountry
    originCountry
    residenceCountry
    city
    address
    job
    liveInUSA
    isPEP
    riskProfile
    riskPoints
    knowledgeProfile
    knowledgePoints
    userProfileSignature
    isKycApproved
    acceptTerms
    userAcceptTermsSignature
    customerStatus
    customerType
    customerCategory
    kycNextStep
    sf_Broker__c
    subaccounts {
      total_deposit_clp
      total_ransom_pen
      total_deposit_usd
      total_ransom_clp
      total_ransom_usd
      total_deposit_pen
      name
      currency
      __typename
    }
    wasIdFileUploaded
    userIdFileSignature
    frontSideIdFilePath
    backSideIdFilePath
    wasAddressFileUploaded
    userAddressFileSignature
    addressFilePath
    wasCardFileUploaded
    userCardFileSignature
    cardFilePath
    wasLivenessFileUploaded
    confirmPhone
    wasPhoneValidate
    wasCreatedInMarketingCloud
    wasCreatedInSalesforce
    needKyc
    require_metamap_upload
    utmSource
    utmMedium
    utmCampaign
    utmId
    createdAt
    updatedAt
    validatePersonalInfo
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateCardFileUploadedMutationVariables,
  APITypes.UpdateCardFileUploadedMutation
>;
export const updateIdentityId = /* GraphQL */ `mutation UpdateIdentityId($id: ID!, $identityId: ID!) {
  updateIdentityId(id: $id, identityId: $identityId) {
    id
    cognitoId
    identityId
    salesforceId
    givenName
    familyName
    email
    phone
    birth
    dni
    signUpCountry
    originCountry
    residenceCountry
    city
    address
    job
    liveInUSA
    isPEP
    riskProfile
    riskPoints
    knowledgeProfile
    knowledgePoints
    userProfileSignature
    isKycApproved
    acceptTerms
    userAcceptTermsSignature
    customerStatus
    customerType
    customerCategory
    kycNextStep
    sf_Broker__c
    subaccounts {
      total_deposit_clp
      total_ransom_pen
      total_deposit_usd
      total_ransom_clp
      total_ransom_usd
      total_deposit_pen
      name
      currency
      __typename
    }
    wasIdFileUploaded
    userIdFileSignature
    frontSideIdFilePath
    backSideIdFilePath
    wasAddressFileUploaded
    userAddressFileSignature
    addressFilePath
    wasCardFileUploaded
    userCardFileSignature
    cardFilePath
    wasLivenessFileUploaded
    confirmPhone
    wasPhoneValidate
    wasCreatedInMarketingCloud
    wasCreatedInSalesforce
    needKyc
    require_metamap_upload
    utmSource
    utmMedium
    utmCampaign
    utmId
    createdAt
    updatedAt
    validatePersonalInfo
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateIdentityIdMutationVariables,
  APITypes.UpdateIdentityIdMutation
>;
export const updateUser = /* GraphQL */ `mutation UpdateUser(
  $input: UpdateUserInput!
  $condition: ModelUserConditionInput
) {
  updateUser(input: $input, condition: $condition) {
    id
    cognitoId
    identityId
    salesforceId
    givenName
    familyName
    email
    phone
    birth
    dni
    signUpCountry
    originCountry
    residenceCountry
    city
    address
    job
    liveInUSA
    isPEP
    riskProfile
    riskPoints
    knowledgeProfile
    knowledgePoints
    userProfileSignature
    isKycApproved
    acceptTerms
    userAcceptTermsSignature
    customerStatus
    customerType
    customerCategory
    kycNextStep
    sf_Broker__c
    subaccounts {
      total_deposit_clp
      total_ransom_pen
      total_deposit_usd
      total_ransom_clp
      total_ransom_usd
      total_deposit_pen
      name
      currency
      __typename
    }
    wasIdFileUploaded
    userIdFileSignature
    frontSideIdFilePath
    backSideIdFilePath
    wasAddressFileUploaded
    userAddressFileSignature
    addressFilePath
    wasCardFileUploaded
    userCardFileSignature
    cardFilePath
    wasLivenessFileUploaded
    confirmPhone
    wasPhoneValidate
    wasCreatedInMarketingCloud
    wasCreatedInSalesforce
    needKyc
    require_metamap_upload
    utmSource
    utmMedium
    utmCampaign
    utmId
    createdAt
    updatedAt
    validatePersonalInfo
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateUserMutationVariables,
  APITypes.UpdateUserMutation
>;
